export enum AnimationSpeed {
    immediate = 0,
    regular = 1000,
    slow = 3000,
}
